import { render } from "./CommodityRecord.vue?vue&type=template&id=c50a959c&scoped=true&ts=true"
import script from "./CommodityRecord.vue?vue&type=script&lang=ts"
export * from "./CommodityRecord.vue?vue&type=script&lang=ts"

import "./CommodityRecord.vue?vue&type=style&index=0&id=c50a959c&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c50a959c"]])

export default __exports__